/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, ScrollView, TouchableOpacity, StyleSheet } from 'react-native';
import { useDispatch } from 'react-redux';
import { isWeb, fullWidth } from '@global/screens';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { showImage } from '@/store/global';

const widthContainer = isWeb ? '100%' : fullWidth - 30;

const CustomerDisplay = ({
  beforeImage = [],
  afterImage = [],
  endGondolaImage = [],
  standeeImage = [],
  cocImage = [],
  userRole = '',
}) => {
  const dispatch = useDispatch();
  const isMerchandiser = userRole === 'merchandiser';
  // B2B-5929: promotor only uploads Regular Display (customer_before_visit)
  const isPromotor = userRole === 'promotor';
  const hasBefore = beforeImage && beforeImage.length > 0;
  const hasAfter = afterImage && afterImage.length > 0;
  const hasEndGondola = endGondolaImage && endGondolaImage.length > 0;
  const hasStandee = standeeImage && standeeImage.length > 0;
  const hasCoc = cocImage && cocImage.length > 0;

  const ImageButton = ({ url, text = '', size = 0 }) => {
    const imgSize = size || (isWeb ? 140 : (widthContainer - 70) / 2);
    return (
      <TouchableOpacity
        onPress={() => {
          dispatch(
            showImage({
              isModal: true,
              text,
              disableCDN: true,
              isMultiple: true,
              allImage: [url],
              url,
              noArrow: true,
            }),
          );
        }}
        style={[styles.imageThumb, { width: imgSize, height: imgSize }]}>
        <Image
          style={{ width: imgSize, height: imgSize }}
          width={imgSize}
          height={imgSize}
          source={url}
          disableCDN={true}
        />
        {text ? (
          <View style={styles.imageCaption}>
            <SociollaText style={styles.imageCaptionText} numberOfLines={2}>
              {text}
            </SociollaText>
          </View>
        ) : null}
      </TouchableOpacity>
    );
  };

  const SectionCard = ({ title, accentColor, data }) => {
    const hasData = data && data.length > 0;

    return (
      <View style={styles.card}>
        {/* Top accent bar */}
        <View style={[styles.cardAccent, { backgroundColor: accentColor }]} />

        {/* Header */}
        <View style={styles.cardHeader}>
          <SociollaText type="semibold" style={styles.cardTitle}>
            {title}
          </SociollaText>
          <View style={styles.photoBadge}>
            <SociollaText style={styles.photoBadgeText}>
              {hasData
                ? `${data.length} Photo${data.length > 1 ? 's' : ''}`
                : 'No photos'}
            </SociollaText>
          </View>
        </View>

        <View style={styles.cardDivider} />

        {/* Photo section */}
        <View style={styles.cardSection}>
          <SociollaText style={styles.sectionLabel}>Photos</SociollaText>
          {hasData ? (
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              <View style={{ flexDirection: 'row' }}>
                {data.map((item, idx) => {
                  const url = typeof item === 'string' ? item : item.url;
                  const text = typeof item === 'object' ? item.text || '' : '';
                  return <ImageButton key={idx} url={url} text={text} />;
                })}
              </View>
            </ScrollView>
          ) : (
            <View style={styles.emptyState}>
              <Image
                style={{ width: 36, height: 36, marginBottom: 8, opacity: 0.5 }}
                width={36}
                height={36}
                svg={true}
                source={require('@assets/img/icons/gallery-grey.svg')}
              />
              <SociollaText style={styles.emptyStateText}>
                No {title.toLowerCase()} photos available
              </SociollaText>
            </View>
          )}
        </View>
      </View>
    );
  };

  if (!hasBefore && !hasAfter && !hasEndGondola && !hasStandee && !hasCoc) {
    return (
      <View style={styles.fullEmptyState}>
        <Image
          style={{ width: 50, height: 50, marginBottom: 14, opacity: 0.7 }}
          width={50}
          height={50}
          svg={true}
          source={require('@assets/img/icons/gallery-grey.svg')}
        />
        <SociollaText type="semibold" style={styles.fullEmptyTitle}>
          No Display Photos
        </SociollaText>
        <SociollaText style={styles.fullEmptySubtitle}>
          No customer display photos recorded for this visit
        </SociollaText>
      </View>
    );
  }

  return (
    <ScrollView
      testID="todo-customer-display-display-container"
      showsVerticalScrollIndicator={false}
      style={{ width: '100%' }}
      contentContainerStyle={{ padding: 15 }}>
      <SectionCard
        title={
          isMerchandiser || isPromotor ? 'Regular Display' : 'Before Visit'
        }
        accentColor={Colors.blue0}
        data={beforeImage}
      />
      {!isPromotor ? (
        <SectionCard
          title={isMerchandiser ? 'Additional Display' : 'After Visit'}
          accentColor={Colors.green1}
          data={afterImage}
        />
      ) : null}
      {hasEndGondola ? (
        <SectionCard
          title="End Gondola"
          accentColor={Colors.purple0}
          data={endGondolaImage}
        />
      ) : null}
      {hasStandee ? (
        <SectionCard
          title="Standee"
          accentColor={Colors.orange0}
          data={standeeImage}
        />
      ) : null}
      {hasCoc ? (
        <SectionCard title="COC" accentColor={Colors.pink0} data={cocImage} />
      ) : null}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  card: {
    width: '100%',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    overflow: 'hidden',
    marginBottom: 14,
  },
  cardAccent: {
    height: 4,
    width: '100%',
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  cardTitle: {
    fontSize: 13,
    color: Colors.blue1,
  },
  photoBadge: {
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 20,
    backgroundColor: Colors.grey15,
  },
  photoBadgeText: {
    fontSize: 11,
    color: Colors.grey13,
  },
  cardDivider: {
    height: 1,
    backgroundColor: Colors.grey0,
  },
  cardSection: {
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  sectionLabel: {
    fontSize: 11,
    color: Colors.grey1,
    marginBottom: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  imageThumb: {
    borderRadius: 8,
    overflow: 'hidden',
    marginRight: 10,
  },
  imageCaption: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: 'rgba(0,0,0,0.55)',
  },
  imageCaptionText: {
    fontSize: 10,
    color: Colors.white,
  },
  emptyState: {
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderStyle: 'dashed',
  },
  emptyStateText: {
    fontSize: 12,
    color: Colors.grey1,
    textAlign: 'center',
  },
  fullEmptyState: {
    padding: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fullEmptyTitle: {
    fontSize: 14,
    color: Colors.blue1,
    marginBottom: 6,
  },
  fullEmptySubtitle: {
    fontSize: 13,
    color: Colors.grey1,
    textAlign: 'center',
    lineHeight: 20,
  },
});

export default CustomerDisplay;
